import React from 'react';

import {Spinner} from "@blueprintjs/core";
const Loading = ({t, height}) => {
    return (
        <div className="loading-wrapper" style={{height}}>
            <div className="loading-container">
                <Spinner />
            </div>
        </div>
    )
    
}
 
export default Loading;